<template>
  <div ref="layout" class="wrapper">
    <navigation-header
      :notificationCount="notificationCount"
      :feedCount="feedCount"/>
      <navigation-sidebar
      @hasNewNotification="updateNotificationCount"
      @hasNewFeed="updateNewFeedCount"/>
      <router-view class="page-wrapper"/>
  </div>
</template>

<script>
import NavigationHeader from '@/components/shared/navigations/NavigationHeader';
import NavigationSidebar from '@/components/shared/navigations/NavigationSidebar';

export default {
  name: 'LoggedInLayout',
  components: {
    'navigation-header': NavigationHeader,
    'navigation-sidebar': NavigationSidebar,
  },
  props: {
  },
  data() {
    return {
      notificationCount: 0,
      feedCount: 0,
    };
  },
  created() {
    this.$eventBus.onToggleSideMenu(this, () => {
      this.$refs.layout.classList.toggle('slide-nav-toggle');
    });
  },
  methods: {
    updateNotificationCount(notificationCount) {
      this.notificationCount = notificationCount;
    },
    updateNewFeedCount(feedCount) {
      this.feedCount = feedCount;
    },
  },
};
</script>

<style lang="scss">
.wrapper {
  height: 100%;
  .page-wrapper {
    overflow: scroll;
  }
  @media screen and (max-width: 974px) {
    -webkit-filter: blur(10px);
    filter: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' ><filter id='blur5'><feGaussianBlur in='SourceGraphic' stdDeviation='5' /></filter></svg>#blur10");
    filter: blur(10px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/layouts/LoggedInLayout.vue